import { createReducer } from "@reduxjs/toolkit";
import {
    InitialState,
} from "./types";
import { reducerHelper } from '../reducerHelper'
import {
    fetchNomenclatureCustomNameDetail,
    fetchNomenclatureCustomNameCreate,
    fetchNomenclatureCustomNameDelete,
    fetchNomenclatureCustomNameEdit
} from "./actions";

const initialState: InitialState = {
    info: {
        data: null,
        loading: false,
        error: null,
    },
    create: {
        loading: false,
        error: null,
    },
    edit: {
        loading: false,
        error: null,
    },
    delete: {
        loading: false,
        error: null,
    }
}

export const nomenclatureCustomNameReducer = createReducer(initialState, (builder) => {
    reducerHelper<InitialState>(builder, fetchNomenclatureCustomNameDetail, 'info', null);
    reducerHelper<InitialState>(builder, fetchNomenclatureCustomNameCreate, 'create', null);
    reducerHelper<InitialState>(builder, fetchNomenclatureCustomNameEdit, 'edit', null);
    reducerHelper<InitialState>(builder, fetchNomenclatureCustomNameDelete, 'delete', null);
})
